import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Directive, NgModule } from '@angular/core';
import { ClassSwitch } from '@js-dot/ui';
import * as i1 from '@ng-dot/ui/tip';
import { DotTipDirective } from '@ng-dot/ui/tip';
const _c0 = ["*"];
const _c1 = ["*", [["header"]]];
const _c2 = ["*", "header"];
function DotListItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "header", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.heading, i0.ɵɵsanitizeHtml);
  }
}
function DotListItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c3 = ["dot-heading", ""];
const _c4 = [[["dd"]], [["", 5, "dt"], ["", 5, "dt"]], [["dt"]]];
const _c5 = ["dd", ":not(dt), :not(dt)", "dt"];
function DotListNameComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dt", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.textContent);
  }
}
function DotListNameComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dt", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.innerHTML, i0.ɵɵsanitizeHtml);
  }
}
function DotListNameComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
    i0.ɵɵprojection(1, 2);
  }
}
const _c6 = ["dot-value", ""];
function DotListValueComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dd", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r0.textContent);
  }
}
function DotListValueComponent_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dd", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.innerHTML, i0.ɵɵsanitizeHtml);
  }
}
function DotListValueComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dt", 1);
    i0.ɵɵtemplate(1, DotListValueComponent_ng_template_0_Conditional_1_Template, 1, 1, "dd", 2)(2, DotListValueComponent_ng_template_0_Conditional_2_Template, 1, 1, "dd", 1);
    i0.ɵɵprojection(3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.textContent ? 1 : ctx_r0.innerHTML ? 2 : -1);
  }
}
function DotListValueComponent_Case_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotListValueComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl");
    i0.ɵɵtemplate(1, DotListValueComponent_Case_2_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const children_r2 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", children_r2);
  }
}
function DotListValueComponent_Case_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotListValueComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotListValueComponent_Case_3_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const children_r2 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", children_r2);
  }
}
class DotListComponent {
  table = true;
  static ɵfac = function DotListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListComponent,
    selectors: [["dot-list"]],
    hostAttrs: [1, "dot-list", "_cut_for_child"],
    hostVars: 5,
    hostBindings: function DotListComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵhostProperty("role.table", ctx.table);
        i0.ɵɵclassProp("_box", !ctx.table)("_table", ctx.table);
      }
    },
    inputs: {
      table: "table"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [":root{--list-cell-pads: 8px;--list-cell-first-dd-style: bold;--list-cell-dd-gap: 8px;--list-cell-description-size: .875em}.dot-list-item{display:block}.dot-list-item:not(:last-child){margin-bottom:20px}.dot-list-item header{font-size:2em}.dot-list-heading,.dot-list-value{display:block}.dot-list-heading dt,.dot-list-heading dd,.dot-list-value dt,.dot-list-value dd{margin:0}.dot-list{display:table;width:100%}.dot-list hr{display:none}.dot-list._table{border-collapse:collapse}.dot-list._table .dot-list-head{display:table-header-group}.dot-list._table .dot-list-head dt{font-weight:700}.dot-list._table .dot-list-body{display:table-row-group}.dot-list._table .dot-list-body .dot-list-item{vertical-align:middle}.dot-list._table .dot-list-body dt{display:none}.dot-list._table .dot-list-body dd dt{display:inherit}.dot-list._table .dot-list-body hr{display:none}.dot-list._table .dot-list-body dl:has(dt+dd+dd) dd:nth-child(2){font-weight:var(--list-cell-first-dd-style)}.dot-list._table .dot-list-body dd:nth-child(3n),.dot-list._table .dot-list-body p.sub{margin-top:var(--list-cell-dd-gap);font-size:var(--list-cell-description-size)}.dot-list._table .dot-list-foot{display:table-footer-group}.dot-list._table .dot-list-item{display:table-row;margin-bottom:inherit}.dot-list._table .dot-list-item header{display:none}.dot-list._table .dot-list-item dt,.dot-list._table .dot-list-item dd{appearance:none}.dot-list._table .dot-list-heading,.dot-list._table .dot-list-value{display:table-cell;padding:var(--list-cell-pads);vertical-align:middle}.dot-list._table .dot-list-heading dd,.dot-list._table .dot-list-value dd{margin:0;padding:0;display:block}.dot-list._table .dot-list-heading{text-align:center}.dot-list ._sort-disable,.dot-list ._filter-disable{opacity:.12}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list',
      template: `
		<ng-content></ng-content>`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list _cut_for_child',
        '[class._box]': '!table',
        '[class._table]': 'table',
        '[role.table]': 'table'
      },
      standalone: false,
      styles: [":root{--list-cell-pads: 8px;--list-cell-first-dd-style: bold;--list-cell-dd-gap: 8px;--list-cell-description-size: .875em}.dot-list-item{display:block}.dot-list-item:not(:last-child){margin-bottom:20px}.dot-list-item header{font-size:2em}.dot-list-heading,.dot-list-value{display:block}.dot-list-heading dt,.dot-list-heading dd,.dot-list-value dt,.dot-list-value dd{margin:0}.dot-list{display:table;width:100%}.dot-list hr{display:none}.dot-list._table{border-collapse:collapse}.dot-list._table .dot-list-head{display:table-header-group}.dot-list._table .dot-list-head dt{font-weight:700}.dot-list._table .dot-list-body{display:table-row-group}.dot-list._table .dot-list-body .dot-list-item{vertical-align:middle}.dot-list._table .dot-list-body dt{display:none}.dot-list._table .dot-list-body dd dt{display:inherit}.dot-list._table .dot-list-body hr{display:none}.dot-list._table .dot-list-body dl:has(dt+dd+dd) dd:nth-child(2){font-weight:var(--list-cell-first-dd-style)}.dot-list._table .dot-list-body dd:nth-child(3n),.dot-list._table .dot-list-body p.sub{margin-top:var(--list-cell-dd-gap);font-size:var(--list-cell-description-size)}.dot-list._table .dot-list-foot{display:table-footer-group}.dot-list._table .dot-list-item{display:table-row;margin-bottom:inherit}.dot-list._table .dot-list-item header{display:none}.dot-list._table .dot-list-item dt,.dot-list._table .dot-list-item dd{appearance:none}.dot-list._table .dot-list-heading,.dot-list._table .dot-list-value{display:table-cell;padding:var(--list-cell-pads);vertical-align:middle}.dot-list._table .dot-list-heading dd,.dot-list._table .dot-list-value dd{margin:0;padding:0;display:block}.dot-list._table .dot-list-heading{text-align:center}.dot-list ._sort-disable,.dot-list ._filter-disable{opacity:.12}\n"]
    }]
  }], null, {
    table: [{
      type: Input
    }]
  });
})();
class DotListHeadComponent {
  static ɵfac = function DotListHeadComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListHeadComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListHeadComponent,
    selectors: [["dot-list-head"]],
    hostAttrs: ["role", "rowgroup", 1, "dot-list-head"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotListHeadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListHeadComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list-head',
      // ul
      template: `
		<ng-content></ng-content>`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-head',
        role: 'rowgroup'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotListBodyComponent {
  static ɵfac = function DotListBodyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListBodyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListBodyComponent,
    selectors: [["dot-list-body"]],
    hostAttrs: ["role", "rowgroup", 1, "dot-list-body", "_dot-target"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotListBodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListBodyComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list-body',
      template: `
		<ng-content></ng-content>`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-body _dot-target',
        role: 'rowgroup'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotListFootComponent {
  static ɵfac = function DotListFootComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListFootComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListFootComponent,
    selectors: [["dot-list-foot"]],
    hostAttrs: ["role", "rowgroup", 1, "dot-list-foot"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotListFootComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListFootComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list-foot',
      template: `
		<ng-content></ng-content>`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-foot',
        role: 'rowgroup'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotListItemComponent {
  heading;
  static ɵfac = function DotListItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListItemComponent,
    selectors: [["dot-list-item"]],
    hostAttrs: ["role", "row", 1, "dot-list-item"],
    inputs: {
      heading: "heading"
    },
    standalone: false,
    ngContentSelectors: _c2,
    decls: 3,
    vars: 1,
    consts: [[3, "innerHTML"]],
    template: function DotListItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵtemplate(0, DotListItemComponent_Conditional_0_Template, 1, 1, "header", 0)(1, DotListItemComponent_Conditional_1_Template, 1, 0);
        i0.ɵɵprojection(2);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.heading ? 0 : 1);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListItemComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list-item',
      // article
      template: `
		@if (heading) {
		  <header [innerHTML]="heading"></header>
		} @else {
		  <ng-content select="header"></ng-content>
		}
		<ng-content></ng-content>
		`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-item',
        role: 'row'
      },
      standalone: false
    }]
  }], null, {
    heading: [{
      type: Input
    }]
  });
})();
class DotListItemValueComponentBase {
  key;
  label;
  textContent;
  innerHTML;
  _keyClass;
  constructor(elementRef) {
    this._keyClass = new ClassSwitch(elementRef.nativeElement);
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (!changes.hasOwnProperty(key)) {
        continue;
      }
      const change = changes[key];
      const value = change.currentValue;
      this[key] = value;
      switch (key) {
        case 'key':
          this.#keyUpdate();
      }
    }
  }
  #keyUpdate() {
    const {
      key,
      _keyClass
    } = this;
    if (key) {
      _keyClass.set('item-' + key);
    } else {
      _keyClass.pop();
    }
  }
  static ɵfac = function DotListItemValueComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListItemValueComponentBase)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotListItemValueComponentBase,
    inputs: {
      key: "key",
      label: "label",
      textContent: "textContent",
      innerHTML: "innerHTML"
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListItemValueComponentBase, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }], {
    key: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    textContent: [{
      type: Input
    }],
    innerHTML: [{
      type: Input
    }]
  });
})();
class DotListNameComponent extends DotListItemValueComponentBase {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotListNameComponent_BaseFactory;
    return function DotListNameComponent_Factory(__ngFactoryType__) {
      return (ɵDotListNameComponent_BaseFactory || (ɵDotListNameComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotListNameComponent)))(__ngFactoryType__ || DotListNameComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListNameComponent,
    selectors: [["dl", "dot-heading", ""]],
    hostAttrs: ["role", "cell", 1, "dot-list-heading"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    attrs: _c3,
    ngContentSelectors: _c5,
    decls: 4,
    vars: 1,
    consts: [[3, "textContent"], [3, "innerHTML"]],
    template: function DotListNameComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c4);
        i0.ɵɵtemplate(0, DotListNameComponent_Conditional_0_Template, 1, 1, "dt", 0)(1, DotListNameComponent_Conditional_1_Template, 1, 1, "dt", 1)(2, DotListNameComponent_Conditional_2_Template, 2, 0);
        i0.ɵɵprojection(3);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.textContent ? 0 : ctx.innerHTML ? 1 : 2);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListNameComponent, [{
    type: Component,
    args: [{
      selector: 'dl[dot-heading]',
      template: `
		@if (textContent) {
			<dt [textContent]="textContent"></dt>
		} @else if (innerHTML) {
			<dt [innerHTML]="innerHTML"></dt>
		} @else {
			<ng-content select=":not(dt), :not(dt)"></ng-content>
			<ng-content select="dt"></ng-content>
		}
		<ng-content select="dd"></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-heading',
        role: 'cell'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotListValueComponent extends DotListItemValueComponentBase {
  tagName;
  constructor(elementRef) {
    super(elementRef);
    this.tagName = elementRef.nativeElement.tagName;
  }
  static ɵfac = function DotListValueComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListValueComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListValueComponent,
    selectors: [["dl", "dot-value", ""], ["a", "dot-value", ""]],
    hostAttrs: ["role", "cell", 1, "dot-list-value"],
    standalone: false,
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: i1.DotTipDirective,
      inputs: ["tip", "tip", "delay", "tipDelay"]
    }]), i0.ɵɵInheritDefinitionFeature],
    attrs: _c6,
    ngContentSelectors: _c0,
    decls: 4,
    vars: 1,
    consts: [["children", ""], [3, "innerHTML"], [3, "textContent"], [4, "ngTemplateOutlet"]],
    template: function DotListValueComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DotListValueComponent_ng_template_0_Template, 4, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, DotListValueComponent_Case_2_Template, 2, 1, "dl")(3, DotListValueComponent_Case_3_Template, 1, 1, "ng-container");
      }
      if (rf & 2) {
        let tmp_1_0;
        i0.ɵɵadvance(2);
        i0.ɵɵconditional((tmp_1_0 = ctx.tagName) === "A" ? 2 : 3);
      }
    },
    dependencies: [i2.NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListValueComponent, [{
    type: Component,
    args: [{
      selector: 'dl[dot-value], a[dot-value]',
      template: `
		<ng-template #children>
			<dt [innerHTML]="label"></dt>
			@if (textContent) {
				<dd [textContent]="textContent"></dd>
			} @else if (innerHTML) {
				<dd [innerHTML]="innerHTML"></dd>
			}
			<ng-content></ng-content>
		</ng-template>
		@switch (tagName) {
			@case ('A') {
				<dl>
					<ng-container *ngTemplateOutlet="children"/>
				</dl>
			}
			@default {
				<ng-container *ngTemplateOutlet="children"/>
			}
		}
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-list-value',
        role: 'cell'
      },
      hostDirectives: [{
        directive: DotTipDirective,
        inputs: ['tip', 'delay:tipDelay']
      }],
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();
class DotListModule {
  static ɵfac = function DotListModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotListModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListModule, [{
    type: NgModule,
    args: [{
      declarations: [DotListComponent, DotListHeadComponent, DotListBodyComponent, DotListFootComponent, DotListItemComponent, DotListNameComponent, DotListValueComponent],
      exports: [DotListComponent, DotListHeadComponent, DotListBodyComponent, DotListFootComponent, DotListItemComponent, DotListNameComponent, DotListValueComponent],
      imports: [CommonModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotListBodyComponent, DotListComponent, DotListFootComponent, DotListHeadComponent, DotListItemComponent, DotListItemValueComponentBase, DotListModule, DotListNameComponent, DotListValueComponent };
